import React from "react";
import { LanguageBox } from "./styles";
import { MenuItem, Select } from "@mui/material";

export default function LanguageChoose() {
  const handleChangeLanguage = (ln) => {
    localStorage.setItem("language", ln);
    window.location.reload();
  };

  return (
    <LanguageBox>
      <Select
        size="small"
        defaultValue={localStorage.getItem("language") || "pt"}
        onChange={(e) => handleChangeLanguage(e.target.value)}
        style={{ backgroundColor: "#FFF" }}
      >
        <MenuItem value="pt">Portuguese</MenuItem>
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="es">Spanish</MenuItem>
      </Select>
    </LanguageBox>
  );
}
